export const LOG_A_CALL = {
    DURATION_MIN_VALUE: 0,
    DURATION_MAX_VALUE: 999,
    COMMENTS_MAX_LENGTH: 1500,
    NEXT_STEPS_MAX_LENGTH: 250,
}

export enum NOTE_TYPES {
    CALL = 'CALL',
    CHAT = 'CHAT',
}

export const ADD_A_NOTE = {
    MAX_NOTE_LENGTH: 4000,
}

export const ACCOUNT_ACTIVITY_CHART_GRIDLINES_COUNT = 7;

export const CUSTOMER_CALLS_LOGGED_CALL_EVENT = 'Logged Call';
export const CUSTOMER_INTERACTIONS_CHAT_EVENT = 'chat';
export const CUSTOMER_TICKET_COMMENTS_EVENT = 'Ticket Comments';
export const CUSTOMER_TICKET_TRANSFERRED_EVENT = 'Ticket Transferred';

export const CATEGORY_TYPES = {
    TICKETS: 'TICKETS',
    CUSTOMER_CALLS: 'CUSTOMER CALLS',
    CUSTOMER_INTERACTIONS: 'CUSTOMER INTERACTIONS',
};

export const MAP_PARAMETERS = {
    TICKET_NUMBER: 'Ticket Number',
    TICKET_SUBJECT: 'Ticket Subject',
    TICKET_WORKGROUP: 'Ticket Workgroup',
    TICKET_COMMENT_DELETED: 'isDeleted',
    TICKET_COMMENT: 'TicketComment',
    TICKET_PUBLIC_COMMENT: 'Public Comment',
    TICKET_TRANSFER_MSG: 'TICKET_TRANSFER_MSG',
}

export const IS_TICKET_COMMENT_DELETED = 'yes';
export const IS_TICKET_COMMENT_PUBLIC = 'yes';
export const COLON_SEPARATOR = ': ';
export const TICKET_COMMENT_HEADER_LENGTH = 40;
export const LAST_DAY_COUNT = 1;
export const LAST_MONTH_COUNT = 1;
export const LAST_WEEK_DAYS_COUNT = 6;
export const LAST_30_DAYS_COUNT = 29;
